import React from "react";
import clsx from "clsx";

import style from "./Avatar.module.scss";

type Props = {
  src: string;
  size: number;
  alt?: string;
};

export default function Avatar({ src, size, alt }: Props) {
  return (
    <div
      className={style.avatarContainer}
      style={{ width: `${size}px`, height: `${size}px` }}
    >
      <img
        src={src}
        className={clsx(style.avatar, "w-100 h-100 rounded-circle")}
        alt={alt}
      />
    </div>
  );
}
